export enum Tags {
    CSharp = 1,
    Unity = 2,
    Javascript = 4,
    WinForms = 8,
    Powershell = 16,
}
